import { defineNuxtRouteMiddleware, navigateTo } from '#imports'
import type { RouteLocationNormalized, RouteParamValue } from 'vue-router'

import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import { ROUTE_NAMES } from '~/scopes/buyback/constants'

function firstParam(
  param: RouteParamValue | RouteParamValue[] | undefined,
): RouteParamValue | undefined {
  return Array.isArray(param) ? param[0] : param
}

// A declarative route `redirect` cannot be used: on SSR Nuxt emits a 302, and SEO needs a 301.
export default defineNuxtRouteMiddleware(function redirectLegacyTradeInProduct(
  to: RouteLocationNormalized,
  from?: RouteLocationNormalized,
) {
  const logger = useLogger()

  const category = firstParam(to.params.category)
  const slug = firstParam(to.params.slug)

  // Without both params we cannot build the new URL: let the page render and 404 on its own.
  if (!category || !slug) {
    return undefined
  }

  const redirect = {
    name: ROUTE_NAMES.TRADE_IN_PRODUCT,
    params: {
      locale: firstParam(to.params.locale),
      category,
      slug,
    },
    query: to.query,
    hash: to.hash,
  }

  logger.info('Trade-in legacy product URL redirection', {
    requestedPath: to.fullPath,
    from: from?.fullPath || from?.path,
    owners: ['bot-squad-circularity-offer-front'],
  })

  return navigateTo(redirect, { redirectCode: 301 })
})
